import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './Components/HomePage';
import Header from './Layouts/Header';
import Footer from './Layouts/Footer';
import EdTech from './Components/EdTech';
import FinanceAccounting from './Components/Finance&Accounting';
import Healthcare from './Components/Healthcare';
import Logistics from './Components/Logistics';
import Retail from './Components/Retail';
import Pharmaceutical from './Components/Pharmaceutical';
import HumanResource from './Components/HumanResource';
import AIML from './Components/AI&ML';
import DataEngineering from './Components/DataEngineering';
import GenerativeAI from './Components/GenerativeAI';
import SoftwareEngineering from './Components/SoftwareEngineering';
import ContactUs from './Components/ContactUs';
import PrivacyPolicy from './Components/PrivacyPolicy';
import Company from './Components/Company';
import ScrollToTop from './Components/ScrollToTop';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/edtech" element={<EdTech />} />
          <Route path="/finance-accounting" element={<FinanceAccounting />} />
          <Route path="/healthcare" element={<Healthcare />} />
          <Route path="/logistics" element={<Logistics />} />
          <Route path="/retail" element={<Retail />} />
          <Route path="/pharmaceutical" element={<Pharmaceutical />} />
          <Route path="/human-resource" element={<HumanResource />} />
          <Route path="/aiml" element={<AIML />} />
          <Route path="/dataengineering" element={<DataEngineering />} />
          <Route path="/generativeai" element={<GenerativeAI />} />
          <Route path="/softwareengineering" element={<SoftwareEngineering />} />
          <Route path="/company" element={<Company />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
